// SS Script
(function ($) {
    console.log('Load Form SS')
    // Consumer Sign up
    if (edMode === true && window.location.href.indexOf('/sign-up') > -1 && queryparams.indexOf('registration=1') > -1 ) {
        setTimeout(() => {
            document.querySelector('input#edit-sms-kit-sms-kit').click();
            document.querySelector('#edit-direct-mail-options-welcome-kit').click();
            document.querySelector('#edit-direct-mail-options--wrapper ~ .js-form-wrapper').style.display = 'block';
        }, 500);
        
        if (queryparams.indexOf('errors=1') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-direct-mail-options-welcome-kit').click();
                document.querySelector('#edit-actions-submit').click();
            }, 500);
        }
    }

    // HCP Page with signup form
    if (edMode === true && window.location.href.indexOf('/healthcare-professionals') > -1 && queryparams.indexOf('registration=1') > -1) {
        setTimeout(() => {
            document.querySelector('#edit-hcp-declaration').click();
            document.querySelector('#edit-direct-mail-options-training-kit').click();
            document.querySelector('#edit-hcpformwrap').style.display = 'block';
            document.querySelector('#edit-actions').style.display = 'block';

            document.querySelector('select#edit-hcp-credentials').classList.add('hoverOptions');
            jQuery('select#edit-hcp-credentials').focus(function () {
                this.size = this.options.length;
            });
            jQuery('select#edit-hcp-credentials').trigger('focus');

        }, 300);

        if (queryparams.indexOf('getproductupdates=1') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-direct-mail-options-training-kit').checked = false;
                document.querySelector('input#edit-direct-mail-options-welcome-kit').click();
            }, 2000);
        }

        // HCP Page with signup form with errors
        if (queryparams.indexOf('errors=1') > -1) {
            setTimeout(() => {
                //document.querySelector('#edit-hcp-declaration').click();
                document.querySelector('.webform-button--submit').click();
            }, 2000);
        }
    }
    
    if (edMode === true && window.location.href.indexOf('/healthcare-professionals') > -1 && queryparams.indexOf('registration=2') > -1) {
        setTimeout(() => {
            document.querySelector('#edit-hcp-declaration').click();
            document.querySelector('#edit-hcp-declaration').checked = true;
            document.querySelector('#edit-hcpformwrap').style.display ="block";
            document.querySelector('#edit-direct-mail-options-training-kit').click();
            document.querySelector('#edit-direct-mail-options--wrapper ~ .js-form-wrapper').style.display = 'block';
            document.querySelector('#edit-actions').style.display = 'block';
        }, 300);

        // HCP Page with signup form with errors
        if (queryparams.indexOf('errors=1') > -1) {
            setTimeout(() => {
                document.querySelector('#edit-hcp-declaration').click();
                document.querySelector('#edit-hcp-declaration').checked = true;
                document.querySelector('.webform-button--submit').click();
            }, 500);
        }
        
    }

    // Savings Registration Page, Step 1
    if(edMode === true && window.location.href.indexOf('/savings-registration') > -1 && queryparams.indexOf('registration=1') > -1 ) {
        if (queryparams.indexOf('errors=1') > -1) {
            setTimeout(() => {
                document.querySelector('.js-form-submit').click();
            }, 200);
        }
    }
    // Savings Registration Page, Step 2
    if (edMode === true && window.location.href.indexOf('/savings-registration') > -1 && queryparams.indexOf('registration=2') > -1) {
        setTimeout(() => {
            document.querySelector('.c-SavingsCard_EliForm').classList.remove('js-show');
            document.querySelector('.c-SavingsCard_RegForm').classList.add('js-show');
            document.querySelector('.c-SavingsCard_Step.Step1').classList.remove('active');
            document.querySelector('.c-SavingsCard_Step.Step2').classList.add('active');
            document.querySelector('.c-SavingsCard_EligibilityToggle').click();
            document.querySelector('input#edit-sms-kit-sms-kit').click();
            document.querySelector('#edit-direct-mail-options-welcome-kit').click();
            document.querySelector('#edit-direct-mail-options--wrapper ~ .js-form-wrapper').style.display = 'block';
        }, 350);

        //nothing selected

        if (queryparams.indexOf('nothingSlected') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-sms-kit-sms-kit').click();
                document.querySelector('input#edit-direct-mail-options-welcome-kit').click();
            }, 500);
        }

        if (queryparams.indexOf('checkboxes') > -1) {
            setTimeout(() => {
                //document.querySelector('input#edit-sms-kit-sms-kit').click();
                document.querySelector('input#edit-direct-mail-options-welcome-kit').click();
                document.querySelector('input#edit-direct-mail-options-training-kit').click();
            }, 5000);
        }

        if (queryparams.indexOf('errors=1') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-sms-kit-sms-kit').click();
                document.querySelector('input#edit-direct-mail-options-welcome-kit').click();
                document.querySelector('#edit-actions-submit--2').click();
            }, 500);
        }
    }
    
    // Unsubscribe
    if (edMode === true && window.location.href.indexOf('/unsubscribe') > -1) {

        if (queryparams.indexOf('registration=patient') > -1) {
                // console.log('unsubscribe');
            setTimeout(() => {
                document.querySelector('#edit-email-address').value = 'janesmith@email.com';
                document.querySelector('#edit-user-type-consumer + .ui-checkboxradio-radio-label').classList.add('ui-checkboxradio-checked');
                document.querySelector('#edit-user-type-consumer').click();
                document.querySelector('#edit-types-of-communication--wrapper').style.display = 'block';
            }, 300);
        }
        
        if (queryparams.indexOf('registration=hcp') > -1) {
            setTimeout(() => {
                document.querySelector('#edit-email-address').value = 'janesmith@email.com';
                document.querySelector('#edit-user-type-hcp + .ui-checkboxradio-radio-label').classList.add('ui-checkboxradio-checked');
                document.querySelector('#edit-user-type-hcp').click();
                document.querySelector('#edit-type-of-communication-hcp--wrapper').style.display = 'block';
            }, 300);
        }

        if (queryparams.indexOf('errors=1') > -1) {
            setTimeout(() => {
                document.querySelector('.webform-button--submit').click();
            }, 500);
        }
    }

    //sms orphan page
    if (edMode === true && window.location.href.indexOf('/sms-sign-up') > -1) {
        if (queryparams.indexOf('errors=1') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-actions-submit').click();
            }, 300);
        }
    }

     //renew saving card page - 1st form
    if (edMode === true && window.location.href.indexOf('/savings-card-sign-up') > -1) {
         
        if (queryparams.indexOf('yes=1') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-determination-of-user-contact-info-contact-info-changed').click();
            }, 300);
        }

        if (queryparams.indexOf('no=1') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-determination-of-user-contact-info-contact-info-same').click();
                document.querySelector('input#edit-actions-submit').click();
            }, 300);
        }

        if (queryparams.indexOf('errors=1') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-actions-submit').click();
            }, 300);
        }

        if (queryparams.indexOf('formerrors=1') > -1) {
            setTimeout(() => {
                document.querySelector('input#edit-actions-submit--2').click();
            }, 300);
        }
    }
    
})(jQuery);